import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { PaginatorModel } from '../models/paginator.model';
import { ValBrowserStorageService } from './val-browser-storage.service';
import { ValStorageService } from './val-storage.service';

@Injectable()
export class ValBrowserStorageResolver implements Resolve<boolean> {
    constructor(
        private _s: ValStorageService,
        private _bs: ValBrowserStorageService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const tmpPage = this._bs.getPage();
        this._s.currentPage = tmpPage && tmpPage.page ? tmpPage.page : new PaginatorModel(0, 0, 0, 30);
        this._s.selectedMainCategoryId = tmpPage && tmpPage.selectedMainCategoryId ? tmpPage.selectedMainCategoryId : null;
        this._s.selectedChildCategoryId = tmpPage && tmpPage.selectedChildCategoryId ? tmpPage.selectedChildCategoryId : null;
        this._s.search = tmpPage && tmpPage.search ? tmpPage.search : null;
        this._s.sort = tmpPage && tmpPage.sort ? tmpPage.sort : null;
        this._s.sortDir = tmpPage && tmpPage.sortDir ? tmpPage.sortDir : 1;
        const cart = this._bs.getCart();
        this._s.cart = cart ? cart : [];
        this._s.editedOrder = this._bs.getOrder();
        this._s.user = this._bs.getCurrentUser();
        return of(true);
    }
}
